// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-navigation-template/src/index.tsx

import baseIcon, { navigationDefaultStyleSheetGetter, defaultNavigationIconGroupProps, defaultNavigationIconShapeSize } from '@bubble-ui/temp-icon-base';
var NavigationIconStoresPath = 'M23.172 24H17v-5h-4v5H6.829A2.98 2.98 0 0 0 7 23v-8.07c.22.033.438.07.666.07 1.495 0 2.813-.748 3.668-1.889C12.188 14.252 13.505 15 15 15c1.493 0 2.812-.748 3.665-1.889.855 1.141 2.172 1.889 3.668 1.889.227 0 .447-.037.666-.07V23c0 .351.06.688.172 1ZM5 9.481 7.774 6h14.453L25 9.481v.662C25 11.718 23.803 13 22.334 13c-1.471 0-2.668-1.282-2.668-2.857h-2c0 1.575-1.195 2.857-2.665 2.857-1.471 0-2.667-1.282-2.667-2.857h-2c0 1.575-1.197 2.857-2.668 2.857C6.196 13 5 11.718 5 10.143v-.662Zm22 .662V8.782L23.19 4H6.81L3 8.782v1.361c0 1.645.794 3.096 2 3.975V23c0 .552-.449 1-1 1H3v2h24v-2h-1a1 1 0 0 1-1-1v-8.882c1.206-.879 2-2.33 2-3.975Z';
var NavigationIconStores = baseIcon('NavigationIconStores', {
  getPath: () => NavigationIconStoresPath,
  defaultStyleSheetGetter: navigationDefaultStyleSheetGetter,
  groupProps: defaultNavigationIconGroupProps,
  shapeSize: defaultNavigationIconShapeSize
});
export default NavigationIconStores;
//# sourceMappingURL=index.js.map